import { applyMiddleware, compose, createStore } from 'redux';
import reducers from '../reducers/index';
import createHistory from 'history/createHashHistory';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const nextRootReducer = require('../reducers/index');

export const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);


const history = createHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routeMiddleware, thunk];

export default function configureStore(initialState) {
  const store = createStore(
    persistedReducer, initialState,
    compose(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      store.replaceReducer(nextRootReducer);
    });
  }
  return { store, persistor };
}
export { history };



// WEBPACK FOOTER //
// ./store/index.js